/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Preview_Event_Number_AriaInputs */



/**
* | output |
* | --- |
* | "Event Number" |
*
* @param {Video_Export_Preview_Event_Number_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_preview_event_number_aria = /** @type {((inputs?: Video_Export_Preview_Event_Number_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Preview_Event_Number_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Numero d'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisnummer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Номер события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件编号")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント番号")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना संख्या")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número do evento")
	return /** @type {LocalizedString} */ ("Event Number")
});